import * as React from 'react'
import connect from './connect'
import { LocationsContent } from './contents'
import SaveButton from '../common/save_button'
import SaveAndGoButton from '../common/save_and_go_button'
import NextButton from '../common/next_button'
import BackButton from '../common/back_button'
import ByTagsSelector from '../by_tags_selector'

type LocationsSelectorProps = {
  locations: Array<any>
  tags: Array<any>
  regions: Array<any>
  isReady: boolean
  approvedLocationIDs: any
  campaignLocationsNeedApproval: any
  exportLocationApprovalsUrl: string
  id: number
  targetFilter: string
  saveSelected: any
  removeItem: any
  removeAll: any
  selectItem: any
  selectAll: any
  selectByTags: any
  filterBy: any
  filterByTags: any
  filterTargetBy: any
  stepBack: any
  companyId: number
  canCreateLocation: boolean
  countries: Array<{ label: string; value: string }>
  locationManagers: Array<{ label: string; value: number }>
}

function LocationsSelector(props: LocationsSelectorProps) {
  const {
    locations,
    tags,
    regions,
    isReady,
    approvedLocationIDs,
    campaignLocationsNeedApproval,
    exportLocationApprovalsUrl,
    id,
    targetFilter,
    saveSelected,
    removeItem,
    removeAll,
    selectItem,
    selectAll,
    selectByTags,
    filterBy,
    filterByTags,
    filterTargetBy,
    stepBack,
    companyId,
    canCreateLocation,
    countries,
    locationManagers,
  } = props

  const handleSave = (e, stepAction = null, next = null) => {
    const locationIDs = locations.reduce((result, location) => {
      if (location.selected) {
        result.push(location.id)
      }
      return result
    }, [])
    if (locationIDs.length) {
      saveSelected(id, locationIDs, [], stepAction, next)
    }
  }

  const handleSaveAndGoToOverview = (e) => {
    handleSave(e, 'save_and_go_to_overview')
  }

  const handleNext = (e) => {
    handleSave(e, null, true)
  }

  const handleBack = () => {
    stepBack(id)
  }

  const actions = {
    removeItem,
    removeAll,
    selectItem,
    selectAll,
    selectByTags,
    filterBy,
    filterByTags,
    filterTargetBy,
  }

  return (
    <div className="locations-selector">
      <LocationsContent
        locations={locations}
        actions={actions}
        tags={tags}
        regions={regions}
        targetFilter={targetFilter}
        ByTagsSelector={ByTagsSelector}
        approvedLocationIDs={approvedLocationIDs}
        campaignLocationsNeedApproval={campaignLocationsNeedApproval}
        exportLocationApprovalsUrl={exportLocationApprovalsUrl}
        companyId={companyId}
        canCreateLocation={canCreateLocation}
        countries={countries}
        locationManagers={locationManagers}
      />
      <div className="row justify-content-start">
        <div className="col-1">
          <BackButton onClick={handleBack} />
        </div>
        <div className="col-0">
          <SaveButton onClick={handleSave} />
        </div>
        {isReady && (
          <div className="col-3">
            <SaveAndGoButton onClick={handleSaveAndGoToOverview} />
          </div>
        )}
        <div className="col-1">
          <NextButton onClick={handleNext} />
        </div>
      </div>
    </div>
  )
}

export default connect(LocationsSelector)
